// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"18":"57e4ae10","586":"09a30df6","606":"c7d62b19","775":"f6eb5941"}[chunkId] + ".css";
};